import dayjs from 'dayjs'
import { CustomColumnGridConfig } from '../types'
import { Box } from '@mui/material'

export const CONSUMPTION_FIELD = 'consumption' as const

const columnsConfig: CustomColumnGridConfig[] = [
  {
    flex: 1,
    minWidth: 150,
    field: 'waterCard',
    headerName: 'מספר כ.מים',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'diameter',
    headerName: 'קוטר מד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'area',
    headerName: 'איזור מדידה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'name',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'meterType',
    headerName: 'סוג המד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 150,
    field: 'installed',
    headerName: 'ת.התקנה',
    filterSpec: { kind: 'date' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },
  {
    width: 150,
    minWidth: 150,
    field: 'lastSeen',
    headerName: 'מועד ק. אחרון',
    filterSpec: { kind: 'date' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },

  {
    flex: 1,
    minWidth: 150,
    field: 'openAlerts',
    headerName: 'סטטוס',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'none' },
    filterable: false,
    renderCell: (params: any) => {
      if (params.value) {
        return (
          <Box
            sx={{
              display: 'flex',
              height: 'fit-content',
              gap: 1,
              overflowY: 'auto',
            }}
          >
            {params.value.map((alert: any, index: number) => {
              return (
                <div key={index}>
                  {alert.name}{' '}
                  {index + 1 !== params.value.length && <span>,</span>}
                </div>
              )
            })}
          </Box>
        )
      } else {
        return <div>-</div>
      }
    },
  },

  {
    width: 150,
    minWidth: 150,
    field: 'endUnitNumber',
    headerName: 'מספר משדר',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'text' },
    filterable: true,
  },
  {
    flex: 1,
    minWidth: 450,
    field: 'itmCoordinates',
    headerName: 'קואורדינטות X,Y על בסיס הרשת הארצית החדשה',
    hideable: true,
    disableAggregation: true,
    filterSpec: { kind: 'none' },
    filterable: false,
    renderCell: (params: any) => {
      if (!params.value) return '-'
      let val = params.value
      if (typeof val === 'string') {
        try { val = JSON.parse(val) } catch { return val }
      }
      if (typeof val === 'object' && val !== null) {
        const x = val.x ?? val.east
        const y = val.y ?? val.north
        if (x != null && y != null) return `${Number(x).toFixed(2)}, ${Number(y).toFixed(2)}`
      }
      return '-'
    },
  },

  // {
  //   flex: 1,
  //   minWidth: 150,
  //   field: 'rValue',
  //   headerName: 'ערך R',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 150,
  //   field: 'q3',
  //   headerName: 'Q3',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 150,
  //   field: 'meterValidityDate',
  //   headerName: 'תאריך גיול מד המים',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 150,
  //   field: 'servicePeriod',
  //   headerName: 'תקופת שירות',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 150,

  //   field: 'fitness',
  //   headerName: 'כשרות',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
  // {
  //   flex: 1,
  //   minWidth: 150,
  //   field: 'measurementTechnology',
  //   headerName: 'טכנולוגיית מדידה',
  //   hideable: true,
  //   disableAggregation: true,
  //   filter: { type: 'search' },
  //   filterable: true,
  // },
]

export default columnsConfig
